import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const CHARACTERS_DNA1 = [
  {
    title: "Data Operations \nExecutive",
    subtitle: "Eg. Telco company",
    items: [
      "Proactive data pipeline \nmonitoring for accelerating \ndata delivery for insights",
      "Self-healing capability for \nImproving efficiency on \nticket resolution",
    ],
    image: "characters/character_1.png",
    next: {
      label: "Data Operations Workbench demo",
      onClick: () => {
        setPreviousPage(1044);
        setCurrentPage(105);
      },
      endIcon: "play",
    },
    gif: "characters/character_dna1_1.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
  },
  {
    title: "Platform & \nOperations Head",
    subtitle: "Eg. Telco company",
    items: [
      "Landscape optimization for \ncost reduction and \noperational efficiency \nimprovement",
      "Cloud FinOps for optimizing \nthe cost of cloud \nconsumption",
    ],
    image: "characters/character_2.png",
    next: {
      label: "Plataform Operations Head",
      onClick: () => {
        setPreviousPage(1044);
        setCurrentPage(110);
      },
      endIcon: "play",
    },
    gif: "characters/character_dna1_2.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
  },
];

export const DATA_CHARACTERS_DNA1 = {
  title: "Challenges solved",
  bgImage: "DNA1/DNA1_intro_03.jpg",
  characters: CHARACTERS_DNA1,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(104),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  actions: [
    {
      label: "Data Operations Workbench demo",
      onClick: () => {
        setPreviousPage(1044);
        setCurrentPage(105);
      },
      endIcon: "play",
    },
  ],
};
